module.exports = __webpack_public_path__ + "img/collaborate_2.1ddec2c9.jpg";